import { DismissibleMessageKey } from '@/services/message-dismissal';

export interface MessageDismissalStatus {
    key: DismissibleMessageKey;
    projectId: number | null;
    value: boolean | null;
}

export interface MessageDismissalReducer {
    readonly items: MessageDismissalStatus[];
}

const initialState: MessageDismissalReducer = {
    items: [],
};

const global = (state = initialState, action): MessageDismissalReducer => {
    switch (action.type) {
        case 'SET_ITEM':
            const newItems = state.items.filter(
                (x) => !(x.key === action.data.key && x.projectId === action.data.projectId)
            );

            newItems.push(action.data);

            return { ...state, items: newItems };
        default:
            return state;
    }
};

export default global;
